<fe-header style="z-index: 10000"></fe-header>
<main>
    <fe-card-landing-title
        [title]="'fe_destinations_country_title' | translate"
        [imageSrc]="'images/atencionclientebaner.jpg' | cdn"
    ></fe-card-landing-title>
    <fe-office-search></fe-office-search>
    <fe-show-city-office-details ngSkipHydration></fe-show-city-office-details>
    <section
        class="country__bottom container px-3 px-lg-8 py-4 d-flex flex-column"
    >
        <h3>{{ 'fe_destinations_country_mexico_title' | translate }}</h3>
        <p>
            {{ 'fe_destinations_country_mexico_first_paragraph' | translate }}
        </p>
        <p>
            {{ 'fe_destinations_country_mexico_second_paragraph' | translate }}
        </p>
    </section>
    <section class="destination__locations__search mb-16 mb-md-20">
        <div
            class="destination__locations__search__container mx-3 py-4 px-0 px-md-4 px-lg-8 d-flex"
        >
            <fe-search-reservation
                class="mb-3 w-100"
                [isNormal]="true"
                [container]="'container-fluid'"
            ></fe-search-reservation>
        </div>
    </section>
</main>
<fe-footer></fe-footer>
